export default __webpack_public_path__ + "static/MediaContentFour-a549fd537f079dec97643a71d6e0e419.webp";